import {AssetResponseItem, MediaAsset, TweetAsset} from "@/@types/AssetTypes.ts";
import {extractFirstURLFromCaption} from "@/utils/func.ts";
import Avatar from "@/components/Avatar.tsx";
import RenderPostCaption from "@/components/ui/RenderPostCaption.tsx";
import URLPreview from "@/components/previews/URLPreview.tsx";
import RenderMediaAsset from "@/components/RenderMediaAsset.tsx";
import React from "react";
import FormattedDate from "@/components/FormattedDate.tsx";

export default function TwitterThreadPreview({
                                             post,
                               post_at,
                               account}:{
    post: TweetAsset
    post_at?: string,
    account?: AssetResponseItem['account']
}){
    const items = post?.post || [];
    return <div>
        <div className={"p-3"}>
            {
                items.map((i)=>{
                    const url = extractFirstURLFromCaption(i.caption);
                    return  <div key={String(i.id)} className={"flex gap-3"}>
                        {
                            account ?
                                <div>
                                    <Avatar alt={account.name} size={48} src={account.picture.url} />
                                </div> : null
                        }
                        <div className="flex-1">
                            {
                                account?
                                    <div className={"flex gap-2 items-center"}>
                                        <span className={"font-semibold"}>{account.name}</span>
                                        <span className={"opacity-50 text-sm"}>@{account.username} &middot; <FormattedDate value={post_at} month={"short"} day={"numeric"} /></span>
                                    </div> : null
                            }
                            <div className={"mb-2"}><RenderPostCaption caption={i.caption} /></div>
                            <RenderTweetAssets assets={i.assets || []} />
                            {
                                url ? <URLPreview
                                    display={"twitter"}
                                    url={url} /> : null
                            }
                        </div>
                    </div>
                })
            }
        </div>

    </div>
}

function RenderTweetAssets({assets}:{
    assets: Array<AssetResponseItem>
}){
    const media = assets.map(({data})=>data as MediaAsset)
    if(assets.length === 0) return null;
    if(assets.length === 1) return <RenderMediaAsset item={media[0]} width={"100%"}/>
    if(assets.length === 2) return <div className={"grid grid-cols-2 gap-1"}>
        <RenderMediaAsset item={media[0]} height={140} />
        <RenderMediaAsset item={media[1]}  height={140} />
    </div>
    if(assets.length === 3) return <div>
        <RenderMediaAsset item={media[0]}  height={140} width={"100%"} />
        <div className={"grid grid-cols-2 mt-1 gap-1"}>
            <RenderMediaAsset item={media[1]} height={140} />
            <RenderMediaAsset item={media[2]}  height={140}  />
        </div></div>
    if(assets.length === 4) return <div className={"grid grid-cols-2 gap-1"}>
           <RenderMediaAsset item={media[0]} height={140}/>
            <RenderMediaAsset item={media[1]} height={140}/>
            <RenderMediaAsset item={media[2]} height={140}/>
            <RenderMediaAsset item={media[3]} height={140}/>
     </div>

}
